module.exports = __webpack_public_path__ + "img/image2.d95c109c.png";